import React, { useState, useEffect } from 'react';
import LVButtonAccion from '../Basicos/LVButtonAccion';
import { LVGridSeleccion } from '../Basicos/LVGridSeleccion';
import { Column } from "devextreme-react/data-grid";
import { DateBox } from 'devextreme-react';
import { function_CON_OperacionesParaImportar_Listar } from 'neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar';

function LVSelectorImportarOperaciones({ onClose, onConfirm }) {
  const [selectedOperacion, setSelectedOperacion] = useState(null);
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const [FechaDesde, setFechaDesde] = useState(new Date(DiasParaDesdeListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaDesdeListados) : Date.now()));
  const [FechaHasta, setFechaHasta] = useState(new Date(DiasParaHastaListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaHastaListados) : Date.now()));
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_CON_OperacionesParaImportar_Listar(await FormateoFechaPara_yyyyMMdd(FechaDesde),
        await FormateoFechaPara_yyyyMMdd(FechaHasta));
      setData(resultData.data)
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const handleConfirm = () => {
    onConfirm(selectedOperacion);
  };

  const handleRowDblClick = (e) => {
    const Item = { ...e.data };
    setSelectedOperacion(Item.IdItem);
    onConfirm(selectedOperacion);
  };

  const handleRowClick = (e) => {
    const Item = { ...e.data };
    setSelectedOperacion(Item.IdItem);
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [FechaDesde, FechaHasta]);

  return (

    <div className='dx-theme-accent-as-background-color'
      style={{
        padding: '20px',
        border: '1px solid #26e9ce',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1500 // El maximo es 9999 pero ojo, porque si le pongo mas de 1500, el selector de fechas queda abajo
      }}>

      <table>
        <tbody>
          <tr>
            <td colSpan={3} align='center' >
              <h3>Seleccionar Operación</h3>
            </td>
          </tr>

          <tr height='20'>
            <td colSpan={3} align='center' >

            </td>
          </tr>

          <tr>
            <td align='right' colSpan={3} >
              <div className='LV-FlexContainer' style={{ display: "flex", alignItems: "center", gap: '20px' }} >
                <label>Rango de Datos</label>

                <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesde} onValueChanged={(e) => setFechaDesde(e.value)} />

                <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHasta} onValueChanged={(e) => setFechaHasta(e.value)} />
              </div>
            </td>
          </tr>

          <tr height='20'>
            <td colSpan={3} align='center' >

            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              {data.length > 0 ? (
                <LVGridSeleccion
                  dataSource={data}
                  id="gridContainer"
                  keyExpr="IdItem"
                  onRowDblClick={handleRowDblClick}
                  onRowClick={handleRowClick}
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                  <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                  <Column caption="Cód.Cliente" dataField="IdCliente" width="80" alignment="Right" dataType="number" />
                  <Column caption="Razón Social" dataField="ABM_EEX_Clientes_RazonSocial" width="100" alignment="Left" dataType="string" />
                  <Column caption="Cód.Proveedor" dataField="IdProveedor" width="80" alignment="Right" dataType="number" />
                  <Column caption="Razón Social" dataField="ABM_EEX_Proveedores_RazonSocial" width="100" alignment="Left" dataType="string" />
                  <Column caption="Cód.Tipo" dataField="IdTipoOperacion" width="80" alignment="Right" dataType="number" />
                  <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth={200} alignment="Left" dataType="string" />
                  <Column caption="Documento" dataField="Factura" width="120" alignment="Left" dataType="string" />
                  <Column caption="C.Financiera" dataField="ABM_CON_CuentasFinancieras_Descripcion" width="400" alignment="Left" dataType="string" />
                  <Column caption="Importe" dataField="ImporteTotal" width="120" alignment="Right" dataType="number" format="currency" />
                </LVGridSeleccion>
              ) : (
                <div className="card-body text-center">
                  <h5 className="card-title">No hay datos</h5>
                </div>
              )}
            </td>
          </tr>
          <tr style={{ height: '30px' }} />
          <tr>
            <td><LVButtonAccion className='dx-theme-background-color' onClick={handleConfirm} Texto="CONFIRMAR" /></td>
            <td width={10}></td>
            <td align='right'><LVButtonAccion className='dx-theme-background-color' onClick={handleCancel} Texto="CANCELAR" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LVSelectorImportarOperaciones;